/*global RefLike*/
export class UnresolvedRefError extends Error {
    /*istanbul ignore next*/
    constructor(ref) {
        super('Referenced value read before it was resolved.');
        this.ref = ref;
        Object.setPrototypeOf(this, UnresolvedRefError.prototype);
    }
}
//# sourceMappingURL=unresolved-ref.error.js.map